/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFCheckbox, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Hidden, InputAdornment, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { margin } from '@mui/system';
import { blockInvalidChar } from 'src/helper/blockInvalidCharNumFld';

export default function CandNewEditEduCompo({
  universityData,
  qualData,
  qualTypeData,
  streamData,
  candidateData,
  candidateEduData,
}) {
  // const [genderArr, setGenderArr] = useState([]);
  const { control, setValue, watch, resetField, trigger, getValues } = useFormContext();
  const [uni, setUni] = useState('');

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'candEdu',
  });

  const watchedCandEdu = watch('candEdu');

  useEffect(() => {
    if (fields.length === 0) {
      append({
        eduSrno: 0,
        university: null,
        othrUni: '',
        qualtype: null,
        qualification: null,
        stream: null,
        candpercnt: 0.0,
        candcgpa: 0.0,
        currentypurs: '',
        edufromDate: null,
        edutoDate: null,
      });
    }
  }, [append, fields.length]);

  const handleAdd = () => {
    append({
      eduSrno: 0,
      university: null,
      othrUni: '',
      qualtype: null,
      qualification: null,
      stream: null,
      candpercnt: 0.0,
      candcgpa: 0.0,
      currentypurs: '',
      edufromDate: null,
      edutoDate: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
    trigger('candEdu');
  };

  return (
    <>
      <Box
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        <Typography variant="h6" sx={{ color: 'text.disabled' }}>
          Educational Details:
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Education
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="h6" sx={{ color: 'primary', mb: 2 }}>
              Education {index + 1}:
            </Typography>

            {/* <RHFTextField
                name={`candEdu[${index}].eduSrno`}
                value={index+1}
              />
            */}
            <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
              <RHFTextField name={`candEdu[${index}].eduSrno`} />
            </Box>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`candEdu[${index}].university`}
                  placeholder="Select University"
                  label={
                    <div>
                      School/University
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={universityData}
                  showPlusIcon
                  prerequisiteMasters={['Country']}
                  getOptionLabel={(option) => option.universityName}
                  onChange={(event, value) => {
                    setValue(`candEdu[${index}].university`, value, { shouldValidate: true });
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.universityName}>
                      {option.universityName}
                    </li>
                  )}
                />
              </Stack>
              {watch(`candEdu[${index}].university`)?.universityName === 'Other' && (
                <Stack spacing={1}>
                  <RHFTextField
                    name={`candEdu[${index}].othrUni`}
                    label={<div>University Name</div>}
                  />
                </Stack>
              )}
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`candEdu[${index}].qualtype`}
                  placeholder="Select Qualification Type"
                  label={
                    <div>
                      Qualification Type
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  showPlusIcon
                  options={qualTypeData}
                  getOptionLabel={(option) => option.masterName}
                  //   value={selectedGender}
                  //   onChange={(event, newValue) => {
                  //     setSelectedGender(newValue);
                  //   }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`candEdu[${index}].qualification`}
                  placeholder="Qualification"
                  label={
                    <div>
                      Qualification<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={qualData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  //   value={selectedGender}
                  //   onChange={(event, newValue) => {
                  //     setSelectedGender(newValue);
                  //   }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`candEdu[${index}].stream`}
                  placeholder="Stream"
                  label={
                    <div>
                      Qualification Stream
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={streamData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  //   value={selectedGender}
                  //   onChange={(event, newValue) => {
                  //     setSelectedGender(newValue);
                  //   }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField
                type="number"
                name={`candEdu[${index}].candpercnt`}
                label={
                  <div>
                    Percentage
                    {!watchedCandEdu?.[index]?.candcgpa && (
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    )}
                  </div>
                }
                placeholder="00.00"
                onWheel={(e) => e.target.blur()}
                onKeyDown={blockInvalidChar}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>%</Box>
                    </InputAdornment>
                  ),
                  inputProps: {
                    min: 0, // Set the minimum value allowed
                    max: 100, // Set the maximum value allowed
                  },
                }}
                rules={{
                  validate: {
                    required: (value, formValues) => {
                      // If percentage is empty, check if CGPA is filled
                      const cgpaValue = formValues?.candEdu?.[index]?.candcgpa;
                      if (!value && !cgpaValue) {
                        return 'Either Percentage or CGPA is required.';
                      }
                      return true;
                    },
                  },
                }}
                onChange={(e) => {
                  // Ensure this field updates
                  setValue(`candEdu[${index}].candpercnt`, e.target.value, {
                    shouldValidate: true,
                  });
                  // Re-validate the dependent CGPA field
                  trigger(`candEdu[${index}].candcgpa`);
                }}
              />

              <RHFTextField
                type="number"
                name={`candEdu[${index}].candcgpa`}
                label={
                  <div>
                    CGPA
                    {!watchedCandEdu?.[index]?.candpercnt && (
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    )}
                  </div>
                }
                placeholder="00.00"
                onWheel={(e) => e.target.blur()}
                onKeyDown={blockInvalidChar}
                inputProps={{ max: 10 }}
                rules={{
                  validate: {
                    required: (value, formValues) => {
                      // If CGPA is empty, check if Percentage is filled
                      const percentageValue = formValues?.candEdu?.[index]?.candpercnt;
                      if (!value && !percentageValue) {
                        return 'Either Percentage or CGPA is required.';
                      }
                      return true;
                    },
                  },
                }}
                onChange={(e) => {
                  const inputVal = e.target.value;
                  const parsedVal = inputVal === '' ? null : parseFloat(inputVal);
                  setValue(`candEdu[${index}].candcgpa`, parsedVal, {
                    shouldValidate: true,
                  });
                  trigger(`candEdu[${index}].candpercnt`);
                }}
              />
            </Box>
            <RHFCheckbox
              name={`candEdu[${index}].currentypurs`}
              label="Currently pursuing"
              labelPlacement="start"
              onChange={(e) => {
                const isChecked = e.target.checked;

                // Update the field value
                setValue(`candEdu[${index}].currentypurs`, isChecked);

                if (isChecked) {
                  // Clear the To Date field immediately
                  setValue(`candEdu[${index}].edutoDate`, null, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }
                trigger(`candEdu[${index}].edutoDate`);
                trigger('candEdu');
              }}
              sx={{
                '&.MuiFormControlLabel-labelPlacementStart': {
                  margin: 0,
                },
              }}
            />
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Controller
                name={`candEdu[${index}].edufromDate`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label={
                      <div>
                        From Date<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      </div>
                    }
                    value={field.value}
                    onChange={(newValue) => {
                      field.onChange(newValue);
                      trigger(`candEdu[${index}].edutoDate`);
                      trigger(`candEdu[${index}].edufromDate`);
                      trigger('candEdu');
                    }}

                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!error,
                        helperText: error?.message,
                      },
                    }}
                    maxDate={new Date()}
                  />
                )}
              />
              <Controller
                name={`candEdu[${index}].edutoDate`}
                control={control}
                rules={{
                  validate: (toDate, formValues) => {
                    // Read live values instead of relying on `watch()` captured at
                    // the last render, so trigger() calls fired synchronously
                    // right after setValue() (e.g. from the checkbox onChange)
                    // always see the up-to-date "currently pursuing" state.
                    const isCurrentlyPursuing =
                      formValues?.candEdu?.[index]?.currentypurs ??
                      getValues(`candEdu[${index}].currentypurs`);

                    if (isCurrentlyPursuing) return true; // Skip validation if pursuing

                    if (!toDate) return 'To Date is required';

                    const fromDate =
                      formValues?.candEdu?.[index]?.edufromDate ??
                      getValues(`candEdu[${index}].edufromDate`);

                    if (!fromDate) return true; // Let "From Date" field handle missing from date

                    const from = new Date(fromDate);
                    const to = new Date(toDate);

                    if (from > to) {
                      return 'To Date must be after From Date';
                    }

                    return true;
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <DatePicker
                    label={
                      <div>
                        To Date
                        {!watchedCandEdu?.[index]?.currentypurs && (
                          <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                        )}
                      </div>
                    }
                    value={
                      watch(`candEdu[${index}].currentypurs`)
                        ? null
                        : field.value instanceof Date && !Number.isNaN(field.value.getTime())
                          ? field.value
                          : null
                    }
                    onChange={(newValue) => {
                      const isCurrentlyPursuing = watch(`candEdu[${index}].currentypurs`);

                      const isValid = newValue instanceof Date && !Number.isNaN(newValue.getTime());

                      if (!isCurrentlyPursuing) {
                        field.onChange(isValid ? newValue : null);
                      } else {
                        field.onChange(null);
                      }

                      // Trigger validation updates
                      trigger(`candEdu[${index}].edufromDate`);
                      trigger(`candEdu[${index}].edutoDate`);
                      trigger('candEdu');
                    }}


                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: watchedCandEdu?.[index]?.currentypurs ? false : !!error,
                        helperText: watchedCandEdu?.[index]?.currentypurs ? '' : error?.message,
                      },
                    }}
                    disabled={watch(`candEdu[${index}].currentypurs`)} // Disable the date picker if currently pursuing is checked
                  />
                )}
              />
            </Box>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              {(fields.length > 1) && (
                <Button
                  size="small"
                  color="error"
                  startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                  onClick={() => handleRemove(index)}
                >
                  Remove
                </Button>
              )}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
CandNewEditEduCompo.propTypes = {
  universityData: PropTypes.array,
  qualData: PropTypes.array,
  qualTypeData: PropTypes.array,
  streamData: PropTypes.array,
  candidateData: PropTypes.object,
  candidateEduData: PropTypes.array,
};